import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-equipment-shop",
  "use": "icon-equipment-shop-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 80 80\" id=\"icon-equipment-shop\">\n<path d=\"M62,57C77,30.8,33.8,2.7,33.8,2.7c13.3,13.3,6,41,1.3,54.3h-2.7c12.4-30.6,1.4-54.3,1.4-54.3c5.9,13.5-6,41.8-11.9,54.3H3.1\n\tc0,0,6.2,18.2,23,20.1c16.9,1.9,40.7-5.6,50.8-20.1L62,57L62,57z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol